<template>
    <div class="preUser expand">
        <modalRecoverPassword ref="modalRecoverTeacher"/>
        <div class="preUser-left">
            <div class="content-login"> 
                <b-link  to="/" style="width: fit-content;">
                    <img class="logo" src="@/assets/img/logo-login.png">
                </b-link>    
                <b-form class="Login">
                    <div class="body">
                        <header>
                            <p>Platform for Teachers</p>
                            <h6 class="sub-title"><span>Login</span></h6>
                        </header>
                        <b-form-group label="Email">
                            <!-- <p>Email</p> -->
                            <b-form-input v-model.trim="user.email" required @keyup.enter="procesarLogin"
                                v-bind:class="{ error: $v.user.email.$error}" @keyup="$v.user.email.$touch()" autocomplete="off"
                            >
                            </b-form-input>
                            <span class="error-input">{{ validationMsgLogin($v.user.email)}}</span>
                        </b-form-group>

                        <b-form-group label="Password">
                            <!-- <p>Password</p> -->
                            <b-icon class="eye" :icon="eyesPassword ? 'eye':'eye-slash'" aria-hidden="true" @click="eyesPassword=!eyesPassword"></b-icon>
                            <b-form-input :type="eyesPassword ? 'password':'text'" v-model.trim="user.password" :placeholder=" eyesPassword ? '*********':'Ingrese la contraseña'" required autocomplete="off"
                                v-bind:class="{ error: $v.user.password.$error}" @keyup="$v.user.password.$touch()" @keyup.enter="procesarLogin"
                            ></b-form-input>
                            <span class="error-input">{{ validationMsgLogin($v.user.password)}}</span>
                        </b-form-group>
                        <b-button variant="primary" class="mb-2 mt-1 w-auto"  @click="procesarLogin" :class="{ loading: isLoading }"><icon name="login" />Login</b-button>
                        <div class="mt-1">
                            <b-link class="link-button"  @click="getModalRecover">Forgot password?</b-link>
                        </div>
                    </div>
                        <p class="mb-0">Not registered yet? <span><a href="/teacher/register" class="link mt-3"><span>Apply</span></a></span></p>
                </b-form>
            </div>
        </div>
        <div class="preUser-right">
            <img src="@/assets/img/login-background3.jpg"  class="no_mb"/>
            <p>{{$t('footer-web.text')}}</p>
        </div>
        <b-toast
            id="toast-login-error"
            variant="none"
            no-close-button
            toaster="b-toaster-top-center"
            >
            <img
                src="@/assets/img/ico-equis.png"
                style="margin-right: 10px; margin-top: -2px"
            />
            {{ messageLogin }}
		</b-toast>
    </div>
    
</template>
<script>
import { PERFILES} from '@/assets/js/appConstants'; 
import { baseInstanceAxios } from '@/assets/js/axiosBase.js';
import { required, email } from 'vuelidate/lib/validators';
import { validationMessage } from 'vuelidate-messages';
import modalRecoverPassword from "@/components/modals/ModalRecoverPassword.vue";
const formMessagesLogin = {
    requiredEmail: function () {
        return this.$t('validations.formMessagesLogin.validate-email')
    },
     requiredPassword: function () {
        return this.$t('validations.formMessagesLogin.validate-password')
    },
    required: function (){
        return this.$t('validations.formMessagesLogin.required')
    },
    email: function (){
        return this.$t('validations.formMessagesLogin.email')
    },
};

export default {
    data:function(){
        return{
            API_URL: process.env.VUE_APP_API_URL,
            user:{
                email:'',
                password:'',
                personsTypeId:PERFILES.PROFESOR
            },
            messageLogin:'',
            isLoading: false,
            eyesPassword:true 
 
        }
    },
    components:{
        modalRecoverPassword
    },
    computed: {
        UserId: {
            get() {
                return this.$store.state.user_id;
            },
            set(value) {
                this.$store.commit('mutateUserId', value);
            }
        },
        User: {
            get() {
                return this.$store.state.user;
            },
            set(value) {
                this.$store.commit('mutateUser', value);
            }
        },
        
    },
    validations: {
        user:{
            email: {
                 requiredEmail:required,
                email
            },
            password: {
                  requiredPassword:required
            }    
        }
            
    },
    mounted() {
        localStorage.setItem('lang', "en");
         
    },
    methods: {
        getModalRecover(){
            this.$refs.modalRecoverTeacher.getShowModal(PERFILES.PROFESOR)
        },
        validationMsgLogin: validationMessage(formMessagesLogin),
        procesarLogin: function() {
            if (!this.isLoading) {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }

                this.logIn();
            }
        },
        logIn: function() {
			this.isLoading = true;
            //this.user.FCM_Token = "";
			baseInstanceAxios
				.post(this.API_URL + `/resources/Persons/ValidateLogin`, this.user)
				.then(response => {
                    console.log("response: ",response)
					if (response.data != null) {
						if(response.data.entity != null){//LOGUEADO CON EXITO
                         console.log("response.data.entity: ",response.data.entity)
                            this.UserId = response.data.entity.id;
                            this.User = {
                                    "id": response.data.entity.id,
                                    "firstName": response.data.entity.firstName,
                                    "lastName": response.data.entity.lastName,
                                    "strFullName": response.data.entity.strFullName,
                                    "email": response.data.entity.email,
                                    "photo": response.data.entity.photo,
                                    "personsTypeId":PERFILES.PROFESOR,
                                    "personTeacherId": response.data.entity.personTeacherId,
                                    "totalClassRequest": response.data.entity.totalClassRequest,
                                     "totalDetail": response.data.entity.totalDetail,
                                    "timeZoneName" : response.data.entity.timeZoneName ? response.data.entity.timeZoneName: 'America/Lima',
                                    "isResponseReceived": response.data.entity.isResponseReceived,
                                }
                           
                            this.$store.commit("mutateAuthToken", response.data.entity.userToken);                           
                            this.$store.commit("mutateIsTeacher", true);
                            this.$store.commit("mutateDatosSidebar", {});
                            this.$store.dispatch("updateFlagPostulant",response.data.entity.flagPostulant)
                             this.$store.dispatch("updateFlagValidateCalifications",response.data.entity.flagValidateCalifications)
                            //this.$router.replace({name:"teacher/dashboard"})
                            localStorage.setItem('lang', "en");
                            this.$i18n.locale = "en";
                            this.$router.push({ name: 'teacher/dashboard' , params:{totalNotifications:response.data.entity.totalNotification }});
                           // this.$router.replace({name:'teacher/dashboard', params:{totalNotifications:response.data.entity.totalNotification }});
						}else{
                            this.messageLogin = response.data.message;
                            this.$bvToast.show("toast-login-error");
                        }
                        this.isLoading = false;
					}
				})
                .catch(function (error) {
                    console.log(error);
                    this.message = this.$t('my-cours.mesage-system-error');
                    this.$bvToast.show("toast-login-error");
                    this.isLoading = false;
                });
		},
    },
};
</script>